import { Button } from "@/components/ui/button";
import { RefusedArticle } from "@/interfaces/PartialReception";
import { Trash2 } from "lucide-react";
import React from "react";

interface RefusedArticleCardProps {
  refusedArticle: RefusedArticle;
  onRemove: () => void;
  isReadOnly?: boolean;
}

const RefusedArticleCard: React.FC<RefusedArticleCardProps> = ({
  refusedArticle,
  onRemove,
  isReadOnly,
}) => {
  const { article, colisCode } = refusedArticle;

  return (
    <div className="overflow-hidden rounded-lg border border-red-500 bg-red-50/40 shadow-sm mt-3">
      <div className="flex items-center gap-3 p-3 sm:gap-4 sm:p-4">
        <div className="relative h-16 w-16 flex-shrink-0 overflow-hidden rounded-md bg-gray-100 sm:h-20 sm:w-20">
          <img
            src={article.image || "/placeholder.svg"}
            alt={article.articleName}
            className="h-full w-full object-cover"
          />
        </div>
        <div className="flex flex-1 flex-col gap-1 min-w-0">
          <div className="flex items-center justify-between gap-2">
            <h3 className="font-semibold text-gray-900">{article.genCode}</h3>
            <span className="text-sm font-medium text-gray-600">
              <span>Qté: </span>
              {article.quantity ?? 1}
            </span>
          </div>
          <p className="text-sm text-gray-600 line-clamp-2">
            {article.articleName}
          </p>
          <div className="flex items-center justify-between gap-2">
            <p className="text-xs text-gray-500">Colis N° {colisCode}</p>
            <span className="rounded-md border border-red-200 bg-red-50 px-2 py-0.5 text-xs font-semibold text-red-600">
              Refusé
            </span>
          </div>
        </div>
        {!isReadOnly && (
          <Button
            variant="outline"
            className="h-9 flex-shrink-0 border-red-200 text-red-600 hover:bg-red-50 hover:text-red-700"
            onClick={onRemove}
          >
            <Trash2 className="h-4 w-4 sm:mr-1" />
            <span className="hidden sm:inline">Retirer</span>
          </Button>
        )}
      </div>
    </div>
  );
};

export default RefusedArticleCard;
